// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import './plugins/google-map';
import 'jquery-match-height';
import LazyLoad from 'vanilla-lazyload';
import objectFitImages from 'object-fit-images';
import {Fancybox} from '@fancyapps/ui';
import barba from '@barba/core';
import {log} from "debug";
import ScrollOut from 'scroll-out';

/* global Swiper */
/* global ajax_object */

/* global L */

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);

    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {


  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * BarbsJS init
   */
  const $body = $(document.body);
  if ($body.data('barba') === 'wrapper') {
    barba.init({
      timeout: 10000,
      transitions: [
        {
          name: 'basic',
          enter: function enter() {
            // Init LazyLoad (for ignore .no-lazyload)
            //lazyLoadInit();
          },
          beforeEnter: function beforeEnter() {
            $('html, body').animate({scrollTop: 0}, 600);
          },
          after: function after() {
            let pageEdit = $(document).find('#bwp-main').data('edit');
            if (pageEdit) {
              $(document).find('#wp-admin-bar-edit > a').attr('href', pageEdit);
            }

            let $formWrapper = $('.form-wrapper');
            if ($formWrapper.length) {
              let formID = $formWrapper.attr('data-form-id');

              $.ajax({
                url: ajax_object.ajax_url,
                type: 'GET',
                data: {
                  form_id: formID,
                  action: 'get_form',
                },
              }).done(function (response) {
                $('.form-wrapper').html(response);

                setTimeout(function () {
                  $formWrapper.find('script').each((index, el) => {
                    window.eval($(el).text());
                  });
                }, 2000);
              });
            }

            // Update elements
            lazyLoadInit();
            slidersInit();
            resizeVideo();
          },
        },
      ],
      prevent: ({el}) =>
        el.classList &&
        (el.classList.contains('ab-item') ||
          el.classList.contains('fancybox-image') ||
          el.hasAttribute('data-fancybox')),
    });
  }

  // Slider with cards
  const $projects = $('.js-slider-with-cards');
  if ($projects.length && typeof Swiper !== 'undefined') {
    $projects.each(function (i, el) {
      const $projects = $(el).closest('.s-slider-with-cards');
      const defaults = {
        loop: false,
        speed: 1000,
        autoHeight: true,
        spaceBetween: 20,
        slidesPerView: 1.25,
        breakpoints: {
          768: {
            slidesPerView: 2.294
          },
          1024: {
            slidesPerView: 3.294
          }
        }
      };
      const options = {};
      if ($projects.find('.swiper-navs').length) {
        options.navigation = {
          prevEl: $projects.find('.swiper-button-prev').get(0),
          nextEl: $projects.find('.swiper-button-next').get(0)
        };
      }
      new Swiper(el, {...defaults, ...options});
    });
  }
  //
  // $('#cardModalSingle').on('show.bs.modal', function (event) {
  //   let button = $(event.relatedTarget);
  //
  //   let title = button.data('title');
  //   let subtitle = button.data('subtitle');
  //   let description = button.data('description');
  //   let iconUrl = button.data('icon-url');
  //
  //   let linkUrl = button.data('link-url');
  //   let linkTarget = button.data('link-target');
  //   let linkTitle = button.data('link-title');
  //
  //   let modal = $(this);
  //   let modalIcon = modal.find('.card-slide-item__icon');
  //   let modalSubtitle = modal.find('.card-slide-item__subtitle');
  //   let modalTitle = modal.find('.card-slide-item__title');
  //   let modalDescription = modal.find('.card-slide-item__description');
  //   let modalLink = modal.find('.card-slide-item__link');
  //
  //   if (iconUrl) {
  //     modalIcon.html('<img src="' + iconUrl + '" alt="">');
  //   } else {
  //     modalIcon.empty();
  //   }
  //
  //   modalSubtitle.text(subtitle);
  //   modalTitle.text(title);
  //   modalDescription.html(description);
  //
  //   if (linkUrl) {
  //     modalLink.attr('href', linkUrl)
  //       .attr('target', linkTarget)
  //       .text(linkTitle)
  //       .show();
  //   } else {
  //     modalLink.hide();
  //   }
  // });

  /**
   * Add fancybox to images
   * a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"], a[href$="webp"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');

  Fancybox.bind('[data-fancybox], .fancybox, a[rel*="album"]');

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    cssProps: {
      visibleY: true,
      viewportY: true,
      scrollPercentY: true,
    },
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
    gformFloatingLabels();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({scrollTop: $target.offset().top - 50}, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Override bootstrap submenu toggle
   */
  $('.navbar .menu-item-has-children').hover(function () {
    if ($(window).width() > 991) {
      $(this).toggleClass('show');
      alignMenuDropdown($(this).children('.dropdown-menu'));
    }
  });

  // Prevent dropdown menu opening out of window
  function alignMenuDropdown($dropdown) {
    if ($dropdown === undefined || !$dropdown.length) return false;
    $dropdown.toggleClass(
      'dropdown-menu-left',
      $dropdown.offset().left + $dropdown.width() > $(window).width()
    );
  }

  // Dropdown menu mobile toggle
  $('.js-dropdown-toggle').bind('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(window).width() <= 991) {
      $(this).closest('.dropdown').toggleClass('show');
    }
  });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    // jQuery code goes here
  });

  // Apply scrolling classes on autoscroll
  $(window).trigger('scroll');

  lazyLoadInit();
  slidersInit();
  scrollToAnchor();
  resizeVideo();
  renderLeaflet();
  initVideoPlayer();
  initJobArchiveSidebar();
  filtersToggler();
  addBackgroundToHeader();
  sliderModalHandler();
}); // END of document ready

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here
  tabsHandler();

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Optimize home slider (mobile)
  setTimeout(() => {
    let $sliderPreview = $('#home-slider-preview');
    let $homeSlider = $('#home-slider');
    if (
      $(window).width() <= 768 &&
      $sliderPreview.length &&
      $homeSlider.length
    ) {
      $sliderPreview.hide();
      $homeSlider.show();
    }
  }, 1200);
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  filtersToggler();
  resizeVideo();
  initJobArchiveSidebar();
});

/**
 * Scripts which runs on scrolling
 */
let lastScrollTop = 0;
$(window).on('scroll', function () {
  let st = $(this).scrollTop();

  if (st > 100) {
    $(document.body)
      .addClass('scrolling')
      .toggleClass('scrolling-up', st < lastScrollTop)
      .toggleClass('scrolling-down', st > lastScrollTop);
  } else if (st > 0) {
    $(document.body)
      .removeClass('scrolling')
      .toggleClass('scrolling-up', st < lastScrollTop)
      .toggleClass('scrolling-down', st > lastScrollTop);
  } else {
    $('body').removeClass('scrolling scrolling-up scrolling-down');
  }

  lastScrollTop = st;
});

/* Scrolling to anchor */
function scrollToAnchor() {
  // Anchor click scrolling
  let topOffset = $(window).width() > 991 ? 100 : 70;
  $(document).on('click', 'a[href^="#"]', function (e) {
    if (
      $(this).attr('href') !== '#' &&
      !$(this).hasClass('fancybox') &&
      $(this).attr('role') !== 'tab'
    ) {
      e.preventDefault();
      let $this = $(this);
      if ($($this.attr('href')).length) {
        $('html, body').animate(
          {
            scrollTop: $($this.attr('href')).offset().top - topOffset + 'px',
          },
          750,
          'swing'
        );
      } else if ($this.attr('href') === '#next') {
        let $sectionToScroll = $this.closest('section').next('section');

        if ($sectionToScroll.length) {
          $('html, body').animate(
            {
              scrollTop: $sectionToScroll.offset().top - topOffset + 'px',
            },
            750,
            'swing'
          );
        }
      }
    }
  });

  // On load *only* if we have anchor on the url
  if (window.location.hash) {
    // smooth scroll to the anchor id
    $('html, body').animate(
      {
        scrollTop: $(window.location.hash).offset().top - topOffset + 'px',
      },
      750,
      'swing'
    );
  }
}

/* Sliders init */
function slidersInit() {
  // Init Swiper
  if ($('.js-home-slider').length && typeof Swiper !== undefined) {
    new Swiper('.js-home-slider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1500,
      spaceBetween: 0,
      slidesPerView: 1,
    });
  }

  // Init Flexible Slider
  let $sliders = $('.js-slider');
  if ($sliders.length && typeof Swiper !== undefined) {
    $sliders.each(function (i, el) {
      let $this = $(el);
      let $section = $this.closest('.s-slider');
      let defaults = {
        loop: true,
        speed: 1500,
        spaceBetween: 0,
        slidesPerView: 2,
      };
      let options = $this.data('options') ?? {};

      if (options.autoplay) {
        options.autoplay = {
          pauseOnMouseEnter: true,
        };
      }

      if (options.navigation) {
        options.navigation = {
          prevEl: $section.find('.swiper-button-prev').get(0),
          nextEl: $section.find('.swiper-button-next').get(0),
        };
      }

      if (options.pagination) {
        options.pagination = {
          el: $section.find('.swiper-pagination').get(0),
          dynamicBullets: true,
          clickable: true,
        };
      }

      new Swiper(el, {...defaults, ...options});
    });
  }
}

// LazyLoad
function lazyLoadInit() {
  // Init LazyLoad (for ignore .no-lazyload).
  let lazyLoadInstance = new LazyLoad({
    elements_selector: 'img[data-lazy-src],.pre-lazyload',
    data_src: 'lazy-src',
    data_srcset: 'lazy-srcset',
    data_sizes: 'lazy-sizes',
    skip_invisible: false,
    class_loading: 'lazyloading',
    class_loaded: 'lazyloaded',
  });

  // Add tracking on adding any new nodes to body to update lazyload for the new images (AJAX for example).
  window.addEventListener(
    'LazyLoad::Initialized',
    function () {
      // Get the instance and puts it in the lazyLoadInstance variable.
      if (window.MutationObserver) {
        let observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (typeof node.getElementsByTagName !== 'function') {
                return;
              }
              let images = node.getElementsByTagName('img');
              if (0 === images.length) {
                return;
              }
              lazyLoadInstance.update();
            });
          });
        });
        let b = document.getElementsByTagName('body')[0];
        let config = {childList: true, subtree: true};
        observer.observe(b, config);
      }
    },
    false
  );
}

// Tabs Handler
function tabsHandler() {
  $('.tabs__headers__title').on('click', function () {
    const $this = $(this);
    const count = $this.data('count');
    const $tabs = $this.closest('.tabs');

    $tabs.find('.tabs__headers__title').removeClass('active');
    $this.addClass('active');

    $tabs.find('.tabs__content-block').removeClass('active').hide();
    $tabs
      .find('.tabs__content-block[data-count="' + count + '"]')
      .addClass('active')
      .fadeIn();
  });
}

document.addEventListener('DOMContentLoaded', gformFloatingLabels);

function gformFloatingLabels() {
  const inputs = document.querySelectorAll('.gfield input, .gfield textarea');

  inputs.forEach(function (input) {
    input.addEventListener('focus', function () {
      input.classList.add('input-focused');
    });

    input.addEventListener('blur', function () {
      input.classList.remove('input-focused');

      if (input.value.trim() !== '') {
        input.classList.add('input-filled');
      } else {
        input.classList.remove('input-filled');
      }
    });

    // Initial check (in case browser autofills or input is pre-filled)
    if (input.value.trim() !== '') {
      input.classList.add('input-filled');
    }
  });
}

// Detect iOS
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

/* Render Leaflet map */
function renderLeaflet() {
  let $leafletMaps = $('.js-leaflet-map');
  if ($leafletMaps.length) {
    $leafletMaps.each(function (i, el) {
      let $map = $(el);
      let mapOptions = $map.data('options');
      let map = L.map(el).setView([mapOptions.lat, mapOptions.lng], mapOptions.zoom);
      let popupContent = '';

      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 20,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);

      let themeIcon = L.icon({
        iconUrl: mapOptions.iconUrl,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -54],
      });

      if (mapOptions.markers.length) {
        $.each(mapOptions.markers, function (i, marker) {
          let popupContent = isIOS() ? marker.content_ios : marker.content;

          L.marker([marker.lat, marker.lng], {icon: themeIcon}).addTo(map).bindPopup(popupContent);
        });
      }

    });
  }
}

function initVideoPlayer() {
  let $videoPlayer = $('.s-video');
  if ($videoPlayer.length) {
    $('.s-video__inner').each(function () {
      const $container = $(this);
      const $playButton = $container.find('.s-video__button');
      const $placeholder = $container.find('.s-video__placeholder');
      const $video = $container.find('video');
      const $videoHolder = $container.find('.videoHolder');
      const $iframe = $container.find('iframe');

      if ($playButton.length && $placeholder.length) {
        $playButton.on('click', function () {
          $placeholder.addClass('is-hidden');
          $playButton.addClass('is-hidden');

          if ($video.length) {
            $video[0].play();
            $video[0].muted = false;
            $video[0].autoplay = true;

            $videoHolder.on('click', function () {
              $placeholder.removeClass('is-hidden');
              $playButton.removeClass('is-hidden');
              $video[0].pause();
            });

          } else if ($iframe.length) {
            let currentSrc = $iframe.attr('src');
            let videoId = currentSrc.match(/\/embed\/(.*?)(?:\?|&|$)/)[1];

            $iframe.attr('src', currentSrc + '&autoplay=1&loop=1&playlist=' + videoId + '&controls=0&modestbranding=1');

            $videoHolder.on('click', function () {
              $placeholder.removeClass('is-hidden');
              $playButton.removeClass('is-hidden');

              $iframe.attr('src', currentSrc + '&autoplay=1&loop=1&playlist=' + videoId + '&controls=0&modestbranding=1');
            });
          }
        });
      }
    });
  }
}

function filtersToggler() {
  if ($(window).width() < 768) {
    $('.job-archive__sidebar-shortcode').hide();

    $('.job-archive__sidebar-title').off('click').on('click', function () {
      const $this = $(this);
      const $content = $this.next('.job-archive__sidebar-shortcode');

      if ($content.is(':visible')) {
        $content.slideUp();
        $this.removeClass('active');
      } else {
        $('.job-archive__sidebar-shortcode').slideUp();
        $('.job-archive__sidebar-title').removeClass('active');
        $content.slideDown();
        $this.addClass('active');
      }
    });
  } else {
    $('.job-archive__sidebar-shortcode').show();
    $('.job-archive__sidebar-title').off('click').removeClass('active');
  }
}

// Add background to header when menu is open on Home Page
function addBackgroundToHeader() {
  const headerMenuButton = $('.navbar-toggler');
  const body = $('body.home');

  if (!body.length) return;

  headerMenuButton.on('click', function () {
    body.toggleClass('menu-open');
  });
}

// Turn Job Archive Sidebar into mobile flyout
function initJobArchiveSidebar() {
  const sidebar = $('.job-archive__sidebar-inner');
  const sortPanel = $('.job-archive__sorting');
  const originalContainer = $('.job-archive__sidebar');
  const toggleBtn = $('.job-archive__filters-btn');

  if (!sidebar.length || !sortPanel.length || !toggleBtn.length || !originalContainer.length) return;

  const isMobile = $(window).width() < 768;

  if (isMobile) {
    if (!sidebar.closest('.job-archive__sorting').length) {
      sortPanel.append(sidebar);
      sidebar.hide();
    }

    toggleBtn.off('click').on('click', function (e) {
      e.preventDefault();

      if (sidebar.is(':visible')) {
        sidebar.slideUp(300, function () {
          sidebar.css('display', '');
        });
        toggleBtn.removeClass('active');
      } else {
        sidebar
          .css('display', 'flex')
          .hide()
          .slideDown(300);
        toggleBtn.addClass('active');
      }

      e.stopPropagation();
    });

    $(document).off('click.sidebar').on('click.sidebar', function (e) {
      if (
        !sidebar.is(e.target) &&
        sidebar.has(e.target).length === 0 &&
        !toggleBtn.is(e.target) &&
        toggleBtn.has(e.target).length === 0
      ) {
        if (sidebar.is(':visible')) {
          sidebar.slideUp(300);
          toggleBtn.removeClass('active');
        }
      }
    });

  } else {
    if (!sidebar.closest('.job-archive__sidebar').length) {
      originalContainer.append(sidebar);
      sidebar.show();
    }

    toggleBtn.off('click').removeClass('active');
    $(document).off('click.sidebar');
  }
}

function sliderModalHandler() {
  const modal = $('.s-slider-with-cards__modal');
  const modalContent = $('.s-slider-with-cards__modal-content-container');
  const loader = $('.loader');

  /**
   * Open modal when clicking on a card
   */
  $(document).on('click', '.card-slide-item__open', function (e) {
    e.preventDefault();

    const index = parseInt($(this).data('index'), 10);
    const pageID = $(this).data('page-id');
    const totalCards = parseInt($(this).data('total-cards'), 10);

    openModal(index, pageID, totalCards);
  });

  /**
   * Handle click on "Volgende" button — open next card
   */
  $(document).on('click', '.card-slide-item__next', function (e) {
    e.preventDefault();

    const currentIndex = parseInt($(this).data('index'), 10);
    const pageID = $(this).data('page-id');
    const totalCards = parseInt($(this).data('total'), 10);

    const nextIndex = currentIndex + 1;

    if (nextIndex <= totalCards) {
      openModal(nextIndex, pageID, totalCards);
    }
  });

  /**
   * Close modal by clicking the close button
   */
  $(document).on('click', '.s-slider-with-cards__modal-close', function () {
    closeModal();
  });

  /**
   * Close modal by clicking outside of modal content
   */
  modal.on('click', function (e) {
    if ($(e.target).is(modal)) {
      closeModal();
    }
  });

  /**
   * Open modal and load content via AJAX
   */
  function openModal(index, pageID, totalCards) {
    loader.fadeIn(150);
    modal.fadeIn(200).css('display', 'flex');

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        nonce: ajax_object.nonce,
        action: 'load_card_modal',
        index: index,
        page_id: pageID,
        total_cards: totalCards
      },
      success: function (response) {
        loader.fadeOut(300);
        if (response.success && response.data.html) {
          modalContent.hide().html(response.data.html).fadeIn(300);
        } else {
          modalContent
            .html('<p class="modal-error">Error: No data to display.</p>')
            .fadeIn(300);
          console.error('Error:', response.data);
        }
      },
      error: function (xhr, status, error) {
        loader.fadeOut(150);
        modalContent
          .html('<p class="modal-error">An error occurred while loading.</p>')
          .fadeIn(300);
        console.error('AJAX error:', error);
      }
    });
  }

  /**
   * Close modal
   */
  function closeModal() {
    modalContent.fadeOut(200, function () {
      modal.fadeOut(200);
    });
  }
}





